import * as React from 'react'
import styled from 'styled-components'
import VimeoPlayer from 'react-player/lib/players/Vimeo'

const StyledVideo = styled.div`
  .video-wrapper object,
  .video-wrapper embed,
  .video-wrapper iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  .video-wrapper {
    position: relative;
    padding-bottom: 56.25%;
    height: 0;
  }
`

export const Video = ({ video }) => {
  return (
    <StyledVideo>
      <div className="video-wrapper">
        <VimeoPlayer url={video} width="100%" height="100%" controls={true} />
      </div>
    </StyledVideo>
  )
}
